import { render, staticRenderFns } from "./TestProcessCard.vue?vue&type=template&id=b49e649a"
import script from "./TestProcessCard.vue?vue&type=script&lang=js"
export * from "./TestProcessCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports